import { $json } from "../axios";
// import Vuex from "vuex";
import { Message } from "element-ui";
// import Vue from "../../main";
Vue.use(Vuex);
const CART_KEYS = "cart_list";
const local = localStorage;
const sess = sessionStorage;
let call;
const store = new Vuex.Store({
  state(a) {
    return {
      cartCount: JSON.parse(local.getItem("cartCount")) || 0,
      cartList: JSON.parse(local.getItem(CART_KEYS)) || {},
      isLogin:
        JSON.parse(sess.getItem("userInfo")) ||
        (JSON.parse(sess.getItem("userInfo")) === 0 ? 0 : undefined),
      isLoginPromise: null,
      cartCheckedList: JSON.parse(local.getItem("cartCheckedList")) || {}, // 购物车的勾选状态
      orderCount: JSON.parse(sess.getItem("orderCount")) || null, // 订单数量
      orderCountPromise: null,
      memoryData: JSON.parse(sess.getItem("memoryData")) || {}, // 页面的筛选状态
      favoriteList: JSON.parse(sess.getItem("favoriteList")) || {}, // 收藏数据
    };
  },
  getters: {
    computedLoginPromise(state) {
      return (
        store.state.isLoginPromise ||
        new Promise((resolve) => {
          resolve({ data: state.isLogin });
        })
      );
    },
  },
  mutations: {
    // 更改购物车总商品数量
    CART_CHANGE(state, num) {
      num < 0 && (num = 0);
      state.cartCount = +num;
      local.setItem("cartCount", JSON.stringify(state.cartCount));
    },
    // 修改指定商品的数量
    UPDATA_PRODUCT_NUMBER(state, product) {
      this.commit(
        "CART_CHANGE",
        product.qty - state.cartList[product.sku].qty + state.cartCount
      );
      state.cartList[product.sku].qty = product.qty;

      local.setItem(CART_KEYS, JSON.stringify(state.cartList));
    },
    // 删除指定的商品
    DELETE_PRODUCT(state, sku) {
      this.commit("CART_CHANGE", state.cartCount - state.cartList[sku].qty);
      delete state.cartList[sku];
      local.setItem(CART_KEYS, JSON.stringify(state.cartList));
    },
    // 更新本地购物车列表(添加)
    UPDATEKEYS(state, product) {
      if (state.cartList[product.sku]) {
        state.cartList[product.sku].qty += product.qty;
      } else {
        state.cartList[product.sku] = {
          sku: product.sku,
          qty: product.qty,
          qouta: product.qouta,
          num: product.num,
        };
      }
      local.setItem(CART_KEYS, JSON.stringify(state.cartList));
      this.commit("CART_CHANGE", state.cartCount + product.qty);
    },
    // 添加商品到购物车
    addLocalCart(state, product) {
      // 判断该规格商品是否超过限购或达到最大值
      let curGoods = state.cartList[product.sku];
      let flag;
      let msg;
      if (curGoods) {
        if (product.qouta) {
          flag = curGoods.qty + product.qty <= product.qouta;
          msg = product.qoutaMsg;
        } else {
          flag = curGoods.qty + product.qty <= product.num;
          msg = product.errorMsg;
        }
      } else {
        flag = true;
      }
      if (!flag) {
        Message({
          type: "error",
          showClose: true,
          message: msg,
        });
      } else {
        // 更新购物车列表
        this.commit("UPDATEKEYS", product);
        Message({
          type: "success",
          showClose: true,
          message: product.successMsg,
        });
        product.callback && product.callback();
      }
    },
    // 删除整个购物车
    DELETE_CART(state) {
      local.removeItem(CART_KEYS);
      state.cartList = {};
      this.commit("CART_CHANGE", 0);
    },
    // 未登录时初始化购物车数量
    OFF_LINE_INIT_CART_COUNT(state) {
      state.cartCount = Object.values(state.cartList).reduce((pre, cur) => {
        return pre + cur.qty;
      }, 0);
      local.setItem("cartCount", state.cartCount);
    },
    // 删除选中商品(未登录时使用)
    DELETE_CHECKED_PRODUCT(state, arr) {
      arr.forEach((item) => {
        delete state.cartList[item];
      });
      this.commit("OFF_LINE_INIT_CART_COUNT");
      local.setItem(CART_KEYS, JSON.stringify(state.cartList));
    },
    // 未登录时弹出登录模块
    OPEN_LOGIN(state, dom) {
      dom.dataset.showSidebar = "true";
    },
    // 储存购物车商品, checked为true则从本地删除该商品, product对象有 sku, checked
    CART_CHECKED_CHANGE(state, product) {
      if (product.checked) {
        delete state.cartCheckedList[product.sku];
      } else {
        state.cartCheckedList[product.sku] = {
          sku: product.sku,
          checked: false,
        };
      }
      local.setItem("cartCheckedList", JSON.stringify(state.cartCheckedList));
    },
    // 登录或退出登录时需要清除购物车所有存储的 checked
    DEL_ALL_CHECKED(state) {
      state.cartCheckedList = {};
      local.removeItem("cartCheckedList");
    },
    // 该方法用于记住各页面筛选项, data应为某个页面的筛选项对像
    MEMORY_SELEAT(state, data) {
      if (data.name === "category") {
        state.memoryData[data.name] = {
          ...state.memoryData[data.name],
          [data.categoryId]: data,
        };
      } else {
        state.memoryData[data.name] = data;
      }
      sess.setItem("memoryData", JSON.stringify(state.memoryData));
    },
    MEMORY_SEARCH(state, data) {
      state.memoryData.search = data;
      sess.setItem("memoryData", JSON.stringify(state.memoryData));
    },
    // 清除分类页记住的筛选项
    DEL_CATEGORY(state, id) {
      if (!state.memoryData["category"]) return;
      delete state.memoryData["category"][id];
      sess.setItem("memoryData", JSON.stringify(state.memoryData));
    },
    // 在切换收藏状态后更新已存储的数据
    UPDATA_FAVORITE_LIST(state, params) {
      /**
       * params: {
       *  symbol: 有值则为添加收藏,
       *  fav_type: 收藏类型，1商品，2商家，3菜单,
       *  fav_content: 对应类型的id，商品id，商家id，菜单id
       * }
       */
      if (!state.favoriteList[params.fav_type]) {
        state.favoriteList[params.fav_type] = [];
      }
      if (params.symbol) {
        delete params.symbol;
        state.favoriteList[params.fav_type].push(params);
      } else {
        const index = state.favoriteList[params.fav_type].findIndex((item) => {
          return item.fav_content == params.fav_content;
        });
        state.favoriteList[params.fav_type].splice(index, 1);
      }
      sess.setItem("favoriteList", JSON.stringify(state.favoriteList));
    },
  },
  actions: {
    // 是否登录
    IS_LOGIN(context, flag) {
      if (
        flag ||
        (context.state.isLogin === undefined && !context.state.isLoginPromise)
      ) {
        context.state.isLoginPromise = $json
          .get("/account")
          .then((res) => {
            sess.setItem("userInfo", JSON.stringify(res.data));
            context.state.isLogin = { ...res.data, ret: res.ret };
            return res;
          })
          .catch((err) => {
            sess.setItem("userInfo", 0);
          })
          .finally(() => {
            context.dispatch("INIT_CART_COUNT");
          });
      }
    },
    // 初始化购物车数量
    INIT_CART_COUNT(context) {
      if (context.state.isLogin) {
        $json.get("cart/api/qty").then((res) => {
          context.commit("CART_CHANGE", res.data);
        });
      } else {
        context.commit("OFF_LINE_INIT_CART_COUNT");
      }
    },
    // 登录时将本地商品加入购物车
    POST_CART(context, lang) {
      // console.log(`/${lang}`, "store");
      $json
        .post("cart/batch", {
          cart: Object.values(context.state.cartList),
        })
        .then((res) => {
          window.location.href = `${lang}`;
          context.commit("DELETE_CART");
        });
    },
    // 获取订单数量
    GET_ORDER_COUNT(context, flag) {
      if (context.state.orderCount && !flag) {
        context.state.orderCountPromise = new Promise((resolve) =>
          resolve({ data: context.state.orderCount })
        );
      } else {
        if (context.state.isLoginPromise || context.state.isLogin) {
          const promise =
            context.state.isLoginPromise ||
            new Promise((resolve) => resolve({ data: context.state.isLogin }));
          promise.then((res) => {
            context.state.orderCountPromise = $json
              .get("gather/api/statistical")
              .then((res) => {
                context.state.orderCount = {
                  pay_wait: res.data.pay_wait,
                  confirm_good_wait: res.data.confirm_good_wait,
                  refund_exchange: res.data.refund_exchange,
                };
                sess.setItem(
                  "orderCount",
                  JSON.stringify(context.state.orderCount)
                );
                return res;
              });
          });
        }
      }
    },
    // 登录时调收藏接口
    GET_FAVORITE_LIST(context) {
      $json
        .get("user_favorite/api")
        .then((res) => {
          const list = {};
          res.data.forEach((item) => {
            list[item.fav_type]
              ? list[item.fav_type].push(item)
              : (list[item.fav_type] = [item]);
          });
          context.state.favoriteList = list;
          sess.setItem("favoriteList", JSON.stringify(list));
        })
        .catch((err) => {
          console.log(err.msg);
        });
    },
  },
});
store.dispatch("IS_LOGIN");
// store.dispatch('GET_ORDER_COUNT')
// store.getters.computedLoginPromise.then((res) => {
//   // 在已登录并且没有存储收藏数据时调接口
//   if (!JSON.parse(sess.getItem("favoriteList"))) {
//     if (store.state.isLogin) {
//       store.dispatch("GET_FAVORITE_LIST");
//     }
//   }
// });
export default store;



// WEBPACK FOOTER //
// ./resources/js/lib/local/cart.js